import { generateDeviceTroubleshootingMessage } from '../blurbs';

import type {
  IUseDeviceTroubleshootingProps,
  IDeviceTroubleshootingValues,
} from '../types';

export const useDeviceTroubleshooting = ({
  closeModal,
  handleSubmit,
  whichPerson,
  otherPerson,
}: IUseDeviceTroubleshootingProps) => {
  const initialValues: IDeviceTroubleshootingValues = {
    deviceThatNeedsTroubleshooting: [],
    reasonForTroubleshooting: [],
    readingTransmission: [],
    bloodPressureMonitor: [],
    glucometer: [],
    weightScale: [],
    pulseOximeter: [],
    peakFlowMeter: [],
    deviceTroubleshootingText: '',
    outcome: null,
    deviceTroubleshootingUnsuccessfulText: '',
    extraDeviceTroubleshooting: [],
    whichPerson,
    otherPerson,
    performedDeviceQC: [],
    controlSolutionOrdered: [],
  };

  const preparedData = (data: IDeviceTroubleshootingValues) => {
    const formData = Object.fromEntries(
      Object.entries(data).filter(([_, value]) => value !== null),
    );

    return {
      deviceThatNeedsTroubleshooting: formData.deviceThatNeedsTroubleshooting,
      reasonForTroubleshooting: formData.reasonForTroubleshooting,
      readingTransmission: formData.readingTransmission,
      bloodPressureMonitor: formData.bloodPressureMonitor,
      glucometer: formData.glucometer,
      weightScale: formData.weightScale,
      pulseOximeter: formData.pulseOximeter,
      peakFlowMeter: formData.peakFlowMeter,
      deviceTroubleshootingText: formData.deviceTroubleshootingText,
      outcome: formData.outcome,
      deviceTroubleshootingUnsuccessfulText:
        formData.deviceTroubleshootingUnsuccessfulText,
      extraDeviceTroubleshooting: formData.extraDeviceTroubleshooting,
      whichPerson: formData.whichPerson,
      otherPerson: formData.otherPerson,
      performedDeviceQC: formData.performedDeviceQC,
      controlSolutionOrdered: formData.controlSolutionOrdered,
    };
  };

  const onSaveForm = (formData: IDeviceTroubleshootingValues) => {
    const preparedValues = preparedData(formData);

    const filteredValues = Object.fromEntries(
      Object.entries(preparedValues).filter(([_, value]) => value !== null),
    ) as IDeviceTroubleshootingValues;

    const message = generateDeviceTroubleshootingMessage(filteredValues);

    handleSubmit(message);
    closeModal();
  };

  return {
    initialValues,
    onSaveForm,
  };
};
